export default __webpack_public_path__ + "5fb67ba.png";